"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.THREE = exports.createScene = exports.createClock = exports.createLights = exports.createCamera = exports.createRenderer = exports.createOrbitControls = exports.createModelController = exports.createTexture = exports.createMesh = exports.createContainer = exports.createModelMeshes = exports.prepareRenderData = exports.calcRotations = exports.buildTexture = exports.parseModel = void 0;
/**
 * Public API bundle of web-hlmv.
 *
 * The original project only ships a React application bundle, which cannot be
 * reused from the outside. This entry re-exports the parts of the library that
 * are required to load and draw a GoldSrc (Half-Life) .mdl model, so that any
 * page can do:
 *
 *   const modelData = HLMV.parseModel(buffer);
 *
 * Build with:
 *   npx webpack --config webpack.api.config.js --mode production
 */
var THREE = __importStar(require("three"));
exports.THREE = THREE;
var modelDataParser_1 = require("./src/lib/modelDataParser");
Object.defineProperty(exports, "parseModel", { enumerable: true, get: function () { return modelDataParser_1.parseModel; } });
var textureBuilder_1 = require("./src/lib/textureBuilder");
Object.defineProperty(exports, "buildTexture", { enumerable: true, get: function () { return textureBuilder_1.buildTexture; } });
var geometryTransformer_1 = require("./src/lib/geometryTransformer");
Object.defineProperty(exports, "calcRotations", { enumerable: true, get: function () { return geometryTransformer_1.calcRotations; } });
var modelRenderer_1 = require("./src/lib/modelRenderer");
Object.defineProperty(exports, "prepareRenderData", { enumerable: true, get: function () { return modelRenderer_1.prepareRenderData; } });
Object.defineProperty(exports, "createModelMeshes", { enumerable: true, get: function () { return modelRenderer_1.createModelMeshes; } });
Object.defineProperty(exports, "createContainer", { enumerable: true, get: function () { return modelRenderer_1.createContainer; } });
Object.defineProperty(exports, "createMesh", { enumerable: true, get: function () { return modelRenderer_1.createMesh; } });
Object.defineProperty(exports, "createTexture", { enumerable: true, get: function () { return modelRenderer_1.createTexture; } });
var modelController_1 = require("./src/lib/modelController");
Object.defineProperty(exports, "createModelController", { enumerable: true, get: function () { return modelController_1.createModelController; } });
var screneRenderer_1 = require("./src/lib/screneRenderer");
Object.defineProperty(exports, "createOrbitControls", { enumerable: true, get: function () { return screneRenderer_1.createOrbitControls; } });
Object.defineProperty(exports, "createRenderer", { enumerable: true, get: function () { return screneRenderer_1.createRenderer; } });
Object.defineProperty(exports, "createCamera", { enumerable: true, get: function () { return screneRenderer_1.createCamera; } });
Object.defineProperty(exports, "createLights", { enumerable: true, get: function () { return screneRenderer_1.createLights; } });
Object.defineProperty(exports, "createClock", { enumerable: true, get: function () { return screneRenderer_1.createClock; } });
Object.defineProperty(exports, "createScene", { enumerable: true, get: function () { return screneRenderer_1.createScene; } });
